import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "zxForum/";

// 论坛 - 列表
export const forumPage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "page", {
    data: _params,
    method: "GET",
  });
};

// 论坛 - 添加
export const forumAdd = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "add", {
    data: _params,
    method: "POST",
  });
};

// 论坛 - 删除
export const forumRemove = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + `remove/${params.id}`, {
    method: "DELETE",
  });
}; 

// 论坛 - 我的论坛
export const forumMyList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myList", {
           data: _params,
           method: "GET",
         });
       };
       
// 论坛 - 论坛点赞
export const forumGiveLike = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "giveLike", {
           data: Qs.stringify(_params),
           method: "POST",
         });
       };
       
// 论坛 - 论坛取消点赞
export const forumCancelLike = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "cancelLike", {
           data: Qs.stringify(_params),
           method: "POST",
         });
       };
// 论坛 - 获取课程公告详情
export const forumView = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "view", {
           data: _params,
           method: "GET",
         });
       };


// WEBPACK FOOTER //
// ./src/fetch/api/forum.js